




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIPOSTLIKEGET= createAsyncThunk(
  "aluminipostlikeGet/aluminipostlikeGet",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const aluminipostlikeGetSlice = createSlice({
  name: "aluminipostlikeGetSlice",
  initialState: {
    aluminipostlikeGet: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaluminipostlikeGet: (state) => {
        state.aluminipostlikeGet.loading = false
        state.aluminipostlikeGet.error = false
        state.aluminipostlikeGet.data = []
        state.aluminipostlikeGet.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIPOSTLIKEGET.fulfilled, (state, action) => {
      state.aluminipostlikeGet = {
        ...state.aluminipostlikeGet,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPOSTLIKEGET.pending, (state, action) => {
      state.aluminipostlikeGet = {
        ...state.aluminipostlikeGet,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPOSTLIKEGET.rejected, (state, action) => {
      state.aluminipostlikeGet = {
        ...state.aluminipostlikeGet,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const aluminipostlikeGetAction = {
    ALUMNIPOSTLIKEGET,
};

export { aluminipostlikeGetAction };
export default aluminipostlikeGetSlice.reducer;
export const {setInitialStateOfaluminipostlikeGet} = aluminipostlikeGetSlice.actions
